(() => {
    const gukbinBox = document.querySelectorAll('.sc-gukbin__item .i-box');
    const gukbinImg = document.querySelectorAll('.sc-gukbin__item .i-box img');
    new setParallax(gukbinBox[0], gukbinImg[0], '-13%', '13%');
    new setParallax(gukbinBox[1], gukbinImg[1], '-7%', '7%');

    const encounterBox = document.querySelectorAll('.sc-encounter__item .i-box');
    const encounterImg = document.querySelectorAll('.sc-encounter__item .i-box img');

    new setParallax(encounterBox[0], encounterImg[0], '-15%', '15%');
    new setParallax(encounterBox[1], encounterImg[1], '-10%', '10%');
    new setParallax(encounterBox[2], encounterImg[2], '-13%', '13%');

})();
